export type LocaleKey = "en" | "nl" | "fr";

export const DEFAULT_LOCALE_KEY: LocaleKey = "en";

export function pickSupportedLocaleKey(
  input: string | undefined | null,
  LOCALES_BY_KEY: Record<LocaleKey, unknown>
): LocaleKey {
  if (!input) {
    return DEFAULT_LOCALE_KEY;
  }

  const normalized = input.trim().toLowerCase();

  // Handle exact keys first (e.g. `en`)
  if (normalized in LOCALES_BY_KEY) {
    return normalized as LocaleKey;
  }

  // Handle BCP-47 forms (e.g. `en-US` -> `en`)
  const base = normalized.split("-")[0];
  if (base in LOCALES_BY_KEY) {
    return base as LocaleKey;
  }

  return DEFAULT_LOCALE_KEY;
}

export function resolveBrowserLocaleKey(
  LOCALES_BY_KEY: Record<LocaleKey, unknown>
): LocaleKey {
  const languages =
    (typeof navigator !== "undefined" && navigator.languages?.length
      ? navigator.languages
      : typeof navigator !== "undefined" && navigator.language
        ? [navigator.language]
        : []) ?? [];

  for (const lang of languages) {
    const key = pickSupportedLocaleKey(lang, LOCALES_BY_KEY);
    if (key) {
      return key;
    }
  }

  return DEFAULT_LOCALE_KEY;
}
